import {useTranslation} from 'react-i18next'
import {Skeleton} from '@/components/ui/skeleton'
import {FichaFacts} from '@/components/ficha-facts'
import {PorQue} from '@/components/ui/por-que'
import type {Ficha} from '@/hooks/empresa/identidad/use-ficha'

const FICHA_FIELDS = [
  'cargo',
  'cargo_descripcion',
  'area',
  'sede',
  'fecha_ingreso',
  'tipo_vinculacion',
  'jornada_turno',
  'nivel_educativo',
  'antiguedad_meses',
  'genero',
  'fecha_nacimiento',
  'eps',
  'afp',
  'arl',
] as const satisfies readonly (keyof Ficha)[]

function isFichaEmpty(ficha: Ficha): boolean {
  return FICHA_FIELDS.every((field) => ficha[field] == null)
}

export function EmployeeFichaSection({
  ficha,
  isLoading,
  isError,
}: {
  ficha: Ficha | undefined
  isLoading: boolean
  isError: boolean
}) {
  const {t} = useTranslation()
  if (isError) {
    return (
      <p className="text-sm text-destructive" data-testid="employee-ficha-error">
        {t('employees.ficha.loadError')}
      </p>
    )
  }
  if (isLoading || !ficha) return <Skeleton className="h-40 w-full" />
  if (isFichaEmpty(ficha)) {
    return (
      <p className="text-sm text-muted-foreground" data-testid="employee-ficha-empty">
        {t('employees.ficha.empty')}
      </p>
    )
  }
  return (
    <div className="space-y-4" data-testid="employee-ficha-facts">
      <FichaFacts ficha={ficha} />
      {ficha.editado_en && (
        <PorQue
          label={t('employees.ficha.deDondeSalio')}
          testId="employee-ficha-edited-porque"
          contenidoTestId="employee-ficha-edited-note">
          {t('employees.ficha.editedBy', {date: ficha.editado_en.slice(0, 10)})}
        </PorQue>
      )}
    </div>
  )
}
